import * as am5 from '@amcharts/amcharts5';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import * as am5xy from '@amcharts/amcharts5/xy';

export const juiceBars = (divId: string) => {
	const root = am5.Root.new(divId);
	root.setThemes([am5themes_Animated.new(root)]);

	const chart = root.container.children.push(
		am5xy.XYChart.new(root, {
			layout: root.verticalLayout,
			panX: false,
			panY: false,
			wheelX: 'none',
			wheelY: 'none',
		})
	);

	chart.children.unshift(
		am5.Label.new(root, {
			text: 'Juice Sales (units)',
			fontSize: 18,
			fontWeight: '700',
			x: 0,
			centerX: 0,
			paddingBottom: 18,
			fill: am5.color(0xffffff), // white title
		})
	);

	const data = [
		{ juice: 'Grape Juice', value: 220, color: am5.color('#5a2a83') },
		{ juice: 'Clamato', value: 120, color: am5.color('#b23a48') },
		{ juice: 'V8 Original', value: 180, color: am5.color('#cf3b2e') },
		{ juice: 'Tropicana Orange Juice', value: 1200, color: am5.color('#ff8c00') },
		{ juice: 'Cranberry', value: 200, color: am5.color('#8a0f2f') },
		{ juice: 'Apple Juice', value: 260, color: am5.color('#c59a3a') },
		{ juice: 'Pineapple Juice', value: 240, color: am5.color('#f2c230') },
		{ juice: 'Carrot Juice', value: 160, color: am5.color('#e86f1f') },
	];

	const xAxis = chart.xAxes.push(
		am5xy.CategoryAxis.new(root, {
			categoryField: 'juice',
			renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30, cellStartLocation: 0.15, cellEndLocation: 0.85 }),
		})
	);
	xAxis.data.setAll(data);
	xAxis.get('renderer').labels.template.setAll({
		fill: am5.color(0xffffff), // white x-axis labels
	});

	const yAxis = chart.yAxes.push(
		am5xy.ValueAxis.new(root, {
			renderer: am5xy.AxisRendererY.new(root, {}),
			min: 0,
			extraMax: 0.1,
		})
	);
	yAxis.get('renderer').labels.template.setAll({
		fill: am5.color(0xffffff), // white y-axis labels
	});

	const series = chart.series.push(
		am5xy.ColumnSeries.new(root, {
			name: 'Sales',
			xAxis,
			yAxis,
			categoryXField: 'juice',
			valueYField: 'value',
			tooltip: am5.Tooltip.new(root, {
				labelText: "{categoryX}\n{valueY.formatNumber('#,###')}",
			}),
		})
	);

	series.get('tooltip')!.label.setAll({ fill: am5.color(0xffffff) }); // white tooltip text

	series.columns.template.adapters.add('fill', (fill, target) => {
		const dc = target.dataItem?.dataContext as any;
		return dc?.color ?? fill;
	});
	series.columns.template.adapters.add('stroke', (stroke, target) => {
		const dc = target.dataItem?.dataContext as any;
		return dc?.color ?? stroke;
	});

	series.columns.template.setAll({
		width: am5.percent(70),
		cornerRadiusTL: 6,
		cornerRadiusTR: 6,
	});

	series.bullets.push(() => {
		return am5.Bullet.new(root, {
			locationY: 0.5,
			sprite: am5.Label.new(root, {
				populateText: true,
				text: "{valueY.formatNumber('#,###')}",
				centerX: am5.p50,
				centerY: am5.p50,
				fill: am5.color(0xffffff), // white in-bar labels
				fontWeight: '600',
			}),
		});
	});

	series.data.setAll(data);

	chart.set('cursor', am5xy.XYCursor.new(root, { behavior: 'none' }));

	return () => root.dispose();
};
